import { BulkAction } from 'civic-champs-shared/api/hooks/useRemoteCollection'
import { Row } from 'react-table'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import CancelDialog from 'civic-champs-shared/core/confirm-dialog/CancelDialog'
import { useCallback } from 'react'
import { useCancelRegistrations } from 'Event/hooks/useCancelRegistrations'
import { RegistrantResponse } from 'Event/interfaces'

const useCancelEventRegistrationsDialog = ({
  eagerRemoveMany,
  selectedRows,
}: {
  eagerRemoveMany: BulkAction<RegistrantResponse>
  selectedRows: Row<RegistrantResponse>[]
}) => {
  const showPrompt = useShowPrompt(CancelDialog)
  const cancelRegistrations = useCancelRegistrations()

  return useCallback(async () => {
    const confirmed = await showPrompt({
      text: `Are you sure you want to cancel ${selectedRows.length} registration(s)?`,
      title: 'Cancel Registrations',
      confirmText: 'Yes',
      cancelText: 'No',
    })

    if (confirmed) {
      const selectedIds = selectedRows.map(({ original }) => original.id)
      const rollback = eagerRemoveMany(selectedIds.map(id => ({ id } as RegistrantResponse)))

      try {
        await cancelRegistrations(selectedIds)
      } catch (error) {
        // error notification is shown by hook
        rollback()
      }
    }
  }, [showPrompt, selectedRows, eagerRemoveMany, cancelRegistrations])
}

export default useCancelEventRegistrationsDialog
